import { HistoryState } from '../../models';

export function getInitialHistoryState(): HistoryState {
  return {
    queryHistory: [],
    queryHistoryEnabled: true,
    clickedResultHistory: { history: [] },
    sessionQueryHistory: []
  };
}
